import React from 'react';
import { ClockIcon, HelpCircleIcon, MehIcon, VideoOffIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = {
  dizzy: MehIcon,
  question: HelpCircleIcon,
  camera: VideoOffIcon,
  clock: ClockIcon
};
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-white" data-id="element-148" data-mp="2vppl32fc7wa4">
      <div className="mx-auto max-w-letter px-4 py-7 text-center sm:px-6 sm:py-8" data-id="element-149" data-mp="39hmc1359s04x">
        <p className="text-[0.68rem] font-extrabold uppercase tracking-[0.14em] text-alert" data-id="element-150" data-mp="35gaqb8pinz20">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-1.5 font-display text-xl uppercase leading-[1.1] tracking-tight text-brand-dark sm:text-3xl" data-id="element-151" data-mp="3jf0oysrzi6sh">
          Querés aprender a instalar cámaras y alarmas, pero no sabés por dónde
          empezar.
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm font-medium leading-snug text-ink-muted" data-id="element-152" data-mp="1k37oun9wglbj">
          Si estás comenzando desde cero, probablemente conozcas alguna de estas
          situaciones:
        </p>

        <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-153" data-mp="obolggrpqjcp">
          {problems.map((problem, i) => {
          const Icon = ICONS[problem.icon];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border-l-4 border-alert bg-mist p-3.5 text-left" data-id="element-154" data-mp="x4i6kutuccyh" data-mpi={i}>
                <h3 className="flex items-start gap-2 text-[0.82rem] font-extrabold uppercase leading-tight tracking-tight text-brand-dark" data-id="element-155" data-mp="171mv31b5skig">
                  <Icon size={17} className="mt-px flex-shrink-0 text-alert" aria-hidden="true" data-id="element-156" data-mp="1bzoc7gp0y9ra" />
                  {problem.title}
                </h3>
                <p className="mt-1.5 text-[0.8rem] font-medium leading-snug text-ink-muted sm:text-sm" data-id="element-157" data-mp="3huhamt7rm1vt">
                  {problem.desc}
                </p>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}